import {useCallback, useEffect} from 'react';

import {useFetchPlotsReservations} from '~api/useFetchPlotsReservation';
import {usePlots} from '~providers/PlotsProvider';

export default function useReservedPlots(enabled?: boolean) {
    const {setReservedPlots} = usePlots();
    const reservedPlots = useFetchPlotsReservations(Boolean(enabled));

    const refetch = useCallback(async () => {
        const newReserved = await reservedPlots.refetch();
        newReserved.data && setReservedPlots(newReserved.data);
    }, []);

    useEffect(() => {
        if (reservedPlots.data) {
            setReservedPlots(reservedPlots.data);
        }
    }, [reservedPlots.data]);

    return refetch;
}
